module.exports = __webpack_public_path__ + "static/media/SF-Pro-Display-Bold.644563f4.otf";